import { render, staticRenderFns } from "./pageDetails.vue?vue&type=template&id=dbfae5be&"
import script from "./pageDetails.vue?vue&type=script&lang=js&"
export * from "./pageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports